'use client';

import { c as _c } from "react/compiler-runtime";
import { Container } from '@/app/components/layouts/container';
import { Item } from '@/app/components/layouts/top-navigation/buying-tools/item';
import { TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import { MENU_LINK_CV, MENU_LINK_LCV } from '@/app/contents/top-navigation';
import type { MenuLinkType } from '@/app/types/top-navigation';
import type { VehicleType } from '@/app/types/vehicle-type';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface BuyingToolsProps {
  vehicleType: VehicleType;
  items: MenuLinkType[];
}
export const BuyingTools = t0 => {
  const $ = _c(17);
  const {
    vehicleType,
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: TOP_NAV_DATA_TEST.buyingToolsNavigation
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = vehicleType === "lcv";
  let t5;
  if ($[3] !== t4) {
    t5 = <Item {...MENU_LINK_LCV} isActiveVehicle={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = vehicleType === "cv";
  let t7;
  if ($[5] !== t6) {
    t7 = <Item {...MENU_LINK_CV} isActiveVehicle={t6} />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5 || $[8] !== t7) {
    t8 = <div className="flex items-center gap-x-4">{t5}{t7}</div>;
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== items) {
    t9 = items.map(_temp);
    $[10] = items;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <div className="flex items-center gap-x-4">{t9}</div>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t8) {
    t11 = <aside className="relative z-50 hidden bg-gray-800 xl:block" {...t3} data-myi-hide={true}><Container as="nav" role="menubar" aria-label="Buying tools navigation" size="desktop-only" className="text-body-2-fixed flex h-10 justify-between gap-4 text-white">{t8}{t10}</Container></aside>;
    $[14] = t10;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
function _temp(item, index) {
  return <Item key={`buying_nav_${index}`} {...item} />;
}